import { hasCapability, type User } from "../base";

export const adjuster = {
  create: (user: User) => hasCapability(user, "adjuster.create"),
  read: (user: User) => hasCapability(user, "adjuster.read"),
  review: (user: User) => hasCapability(user, "adjuster.review"),
};
